import { useState } from "react";
import moment from "moment";
import momentTimezone from "moment-timezone";
import matchSorter from "match-sorter";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import Util from "../../../global/utils/Helpers";
import stateResolver from "../../../data/utils/stateUtil";
import { LinkingResolver, PWDResolver } from "../../../data/queries/linking";
import { ReuseResolver } from "../../../data/queries/reuse";
import { stateAbbreviationResolver } from "../../../data/utils/stateUtil";
import util from "../../../global/utils/Helpers";

/**
 * Returns a promise
 * @param {*} caseNumber case number to fetch data from datahub_cases
 */
//TODO(out-of-networklinking): remove linkToFormId later
const getDatahubCase = (caseNumber, formId, fields, linkToFormId) => {
  let query = `query {
    getDatahubCase(
      caseNumber: "${caseNumber}",
      formId: "${formId}",
      linkToFormId: "${linkToFormId}",
      ) {
        ${fields}
      }
    }`;
  return Util.handleGraphql(query);
};
const getDatahubCaseForReuse = (caseNumber, formId, fields, formVersionId) => {
  let query = `query {
    reuseCase(
      caseNumber: "${caseNumber}",
      formId: "${formId}",
      formVersionId: ${formVersionId},
      ) {
        ${fields}
      }
    }`;
  return Util.handleGraphql(query);
};

export const fetchLinkingCaseData = (caseNumber, formType) => {
  const fields = LinkingResolver(formType);
  const formId = PWDResolver(formType);
  //TODO(out-of-networklinking): remove linkToFormId later
  const linkToFormId = formType;

  return getDatahubCase(caseNumber, formId, fields, linkToFormId);
};

export const fetchCaseReuseData = (caseNumber, formId, formVersionId) => {
  // REFACTOR: reuse different form's fields
  const fields = ReuseResolver(formId, formVersionId);
  return getDatahubCaseForReuse(caseNumber, formId, fields, formVersionId);
};

/**
 *
 * @param {*} initialValue the value the hook was initialized with
 */
export function useHandleSectionSelect(initialValue) {
  const [selectedSections, setSelectedSections] = useState(initialValue);
  const [allSelected, setAllSelected] = useState(false);

  function toggleSection(section) {
    let new_sections = selectedSections.slice();

    if (selectedSections.includes(section)) {
      new_sections.splice(new_sections.indexOf(section), 1);
      setSelectedSections(new_sections);
    } else {
      new_sections.push(section);
      setSelectedSections(new_sections);
    }
  }

  function resetSelectedSections() {
    setSelectedSections([]);
  }

  function toggleSelectAllSections(validSections) {
    if (selectedSections.length < validSections.length) {
      setSelectedSections(validSections);
      setAllSelected(true);
    } else {
      resetSelectedSections();
      setAllSelected(false);
    }
  }

  return [
    selectedSections,
    toggleSection,
    resetSelectedSections,
    toggleSelectAllSections,
    allSelected,
  ];
}

export const getMachinesNamesBySections = (
  sections,
  formType,
  formVersionId
) => {
  if (sections.length < 1) {
    return undefined;
  }

  let fields = [];
  let formVersionIdPath =
    formType === "790A" && formVersionId <= 2 ? `V${formVersionId}` : "";

  let sectionSchema = UISchemaResolver(`${formType}${formVersionIdPath}-reuse`);

  sections.forEach((section) => {
    fields = fields.concat(sectionSchema[section]);
  });

  return fields;
};

export const filterOnSearchTerm = (array, searchTerm) => {
  const oldKeys = [
    "case_number",
    "employer",
    "fein",
    "soc_title",
    "soc_code",
    "submitted_date",
  ];
  const newKeys = [
    "caseNumber",
    "empBusinessName",
    "suggestedSocTitle",
    "first_name",
    "last_name",
  ];
  return matchSorter(array, searchTerm, {
    keys: [...oldKeys, ...newKeys],
  });
};

const convertToYesNo = (stringNumber) => {
  if (stringNumber) return Boolean(Number(stringNumber)) ? "YES" : "NO";
  return "NO";
};
const convertToYesNA = (stringNumber) => {
  if (stringNumber) return Boolean(Number(stringNumber)) ? "YES" : "N/A";
  return "N/A";
};

const convertToYesNoNA = (value) => {
  let resolver = {
    0: "No",
    1: "Yes",
    2: "N/A",
  };
  return resolver[value] || "No";
};

const convertToNumber = (stringNumber) => {
  if (stringNumber) return Number(stringNumber);
  return 0;
};

const convertToDate = (stringDate) => {
  let string_date = moment(new Date(stringDate).toISOString()).format(
    "YYYY-MM-DD"
  );
  string_date = `${string_date}T17:00:00.000Z`;
  if (stringDate) return string_date;
  return undefined;
};

const convertUnixDate = (unixString) => {
  let string_date = momentTimezone(parseInt(unixString))
    .tz("GMT")
    .format("YYYY-MM-DD");
  string_date = `${string_date}T17:00:00.000Z`; // matching what's in convertToDate, for datePicker
  if (unixString) return string_date;
  return undefined;
};

const convertToLowerCase = (string) => {
  if (string) return string.toLowerCase();
  return undefined;
};

const convertEducation = (value) => {
  const val = value.trim();
  const resolver = {
    None: "none",
    "High School/GED": "HS/GED",
    "Associate's": "associate",
    "Bachelor's": "bachelor",
    "Master's": "master",
    "Other degree (JD, MD, etc.)": "other",
  };
  return resolver[val] || "none";
};

const convertSummaryPrefixToTitle = (value) => {
  const val = value.trim();
  const resolver = {
    "A.8a": "Job Duties",
    "A.8g": "Overtime Pay",
    "A.11": "Minimum Productivity/Performance Standards",
    "B.6": "Job Qualifications/Requirements",
    "E.1a": "Provision of Meals",
    "E.2": "Daily Transportation",
    "E.3a": "Inbound/Outbound Transportation",
    "E.4": "Deductions from Pay",
    "E.5": "Other Material Terms and Conditions",
  };
  return resolver[val] || "";
};

const convertSummaryPrefixToTitleV2 = (value) => {
  const val = value?.trim();
  const resolver = {
    "A.8a": "Job Duties",
    "A.11": "Pay Deductions",
    "B.6": "Job Requirements",
    "E.1": "Meal Provision",
    "F.1": "Daily Transportation",
    "F.2": "Inbound/Outbound Transportation",
    "G.1": "Referral and Hiring Instructions",
  };
  return resolver?.[val] || "";
};

const convertPer = (value) => {
  const resolver = {
    Hourly: "Hour",
    Weekly: "WK",
    Biweekly: "BW",
    Monthly: "MO",
    Other: "other",
  };
  return resolver[value] || "none";
};

export const buildInitialValues = (
  formValues,
  selectedSections,
  formType,
  formVersionId
) => {
  let initialValues = {};
  const fieldsToPrefill = getMachinesNamesBySections(
    selectedSections,
    formType,
    formVersionId
  );

  fieldsToPrefill.forEach((field) => {
    if (formValues[field] !== "") {
      initialValues[field] = formValues[field];
    }
  });

  if (formType === "9035") {
    const convert_to_yes_no_9035 = ["b4_is_full_time", "g1_read_agree"];

    const convert_to_date_9035 = ["b5_begin_date", "b6_end_date"];

    if (
      initialValues["e1_is_represented"] === "1" &&
      initialValues["e17_agent_bar_number"] !== ""
    ) {
      initialValues["e1_is_represented"] = "Attorney";
    } else if (
      formValues["e1_is_represented"] === "1" &&
      initialValues["e17_agent_bar_number"] === ""
    ) {
      initialValues["e1_is_represented"] = "Agent";
    } else {
      initialValues["e1_is_represented"] = "None";
    }

    convert_to_yes_no_9035.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertToYesNo(initialValues[string]);
      }
    });

    convert_to_date_9035.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertUnixDate(initialValues[string]);
      }
    });
  }

  if (formType === "9089") {
    const convert_to_yes_no_na_9089 = [
      "supervisedRecruitment",

      "empWorkerInterest",
      "empRelationshipWorker",
      "fwInfoAttyorAgent",
      "fwInfoAppxAAttached",
      "jobOppPWDAttached",
      "isMultipleLocations",

      "acceptDiplomaPwd",
      "emPlayoff",
      "empPayEducation",
      "emprecpayment",
      "empRelyExp",
      "empUseCredential",
      "empWillAccept",
      "fwGainExp",
      "isEmpProvidedCont",
      "isFullTimeEmp",
      "isFwCurrentlyWrk",
      "isFwexecutedCont",
      "isFwQualify",
      "isLiveInHousehold",
      "isPaidExperience",
      "jobComboOccup",
      "jobEmpPremises",
      "jobForeignLanguage",
      "jobReqExceed",

      "empUseCredential",

      "sundayPaperExists",
    ];
    const convert_state_abbr_9089 = [
      "empState",
      "empPocState",
      "attyAgState",
      "primaryWorksiteState",
      "appAExpStateTerritory",
      "attyAgGoodStandingState",
    ];

    const convertIncludedFields = (checkField) => {
      let result;
      if (initialValues[checkField]) {
        result = 1;
      } else {
        result = null;
      }
      return result;
    };

    const set_included_fields_9089 = [
      { checkField: "jobFairFrom", setField: "jobFairIncluded" },
      {
        checkField: "employerWebsiteFrom",
        setField: "employerWebsiteIncluded",
      },
      {
        checkField: "jobSearchWebsiteFrom",
        setField: "jobSearchWebsiteIncluded",
      },
      {
        checkField: "onCampusRecruitingFrom",
        setField: "onCampusRecruitingIncluded",
      },
      {
        checkField: "tradeProfessionalFrom",
        setField: "tradeProfessionalIncluded",
      },
      {
        checkField: "privateEmploymentFrom",
        setField: "privateEmploymentIncluded",
      },
      {
        checkField: "employeeReferralFrom",
        setField: "employeeReferralIncluded",
      },
      {
        checkField: "campusPlacementFrom",
        setField: "campusPlacementIncluded",
      },
      {
        checkField: "localEthnicNewspaperFrom",
        setField: "localEthnicNewspaperIncluded",
      },
      { checkField: "radioTvAdFrom", setField: "radioTvAdIncluded" },
    ];

    set_included_fields_9089.forEach(({ checkField, setField }) => {
      if (initialValues[checkField]) {
        initialValues[setField] = convertIncludedFields(checkField);
      }
    });
    const convert_to_date_9089 = [
      "swaJobOrderStartDate",
      "swaJobOrderEndDate",
      "newspaperAdPlacedDate",
      "journalAdPlacedDate",
      "jobFairFrom",
      "jobFairTo",
      "employerWebsiteFrom",
      "employerWebsiteTo",
      "jobSearchWebsiteFrom",
      "jobSearchWebsiteTo",
      "onCampusRecruitingFrom",
      "onCampusRecruitingTo",
      "tradeProfessionalFrom",
      "tradeProfessionalTo",
      "privateEmploymentFrom",
      "privateEmploymentTo",
      "employeeReferralFrom",
      "employeeReferralTo",
      "campusPlacementFrom",
      "campusPlacementTo",
      "localEthnicNewspaperFrom",
      "localEthnicNewspaperTo",
      "radioTvAdFrom",
      "radioTvAdTo",
      "appAContDOB",
      "appDForeignWorkerDate",
      "appDPublicationDate1",
      "appDPublicationDate2",
      "appDPublicationDate3",
    ];

    convert_to_date_9089.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertUnixDate(initialValues[string]);
      }
    });

    const replaceOccupationType = (key) => {
      const occupationType = {
        "Professional occupation": "professional_occupation",
        "Non-professional": "non_professional",
        "College/University Teacher": "college_university_teacher",
        "Schedule A": "schedule_a",
        "None/Professional Athlete": "professional_athlete",
      };
      return occupationType[key] || null;
    };

    if (initialValues["occupationType"]) {
      initialValues["occupationType"] = replaceOccupationType(
        initialValues["occupationType"]
      );
    }

    if (initialValues["advertisementMethod"]) {
      const resolver = {
        1: "newspaper",
        2: "professional-journal",
        3: "n/a",
      };
      initialValues["advertisementMethod"] =
        resolver[initialValues["advertisementMethod"]] || null;
    }

    if (initialValues["appAContAdmClassId"]) {
      const resolver = {
        PERM: "N/A",
        "E-3 Australian": "B-2",
        "H-1B": "A1/A2",
        "H-1B1 Singapore": "B-1",
        "H-2A": "E-1",
        "H-2B": "C-1",
        "CW-1": "CW-1",
      };
      initialValues["appAContAdmClassId"] =
        resolver[initialValues["appAContAdmClassId"]] || null;
    }

    convert_to_yes_no_na_9089.forEach((field) => {
      if (initialValues[field] !== undefined) {
        initialValues[field] = convertToYesNoNA(initialValues[field]);
        if (field === "sundayPaperExists") {
          initialValues[field] = convertToLowerCase(initialValues[field]);
        }
      }
    });

    if (
      initialValues?.fwExpAppE?.[0]?.appAExpFWPresent &&
      initialValues?.fwExpAppE?.[0]?.appAExpFWPresent !== undefined
    ) {
      initialValues["fwExpAppE"][0]["appAExpFWPresent"] = convertToYesNoNA(
        initialValues["fwExpAppE"][0]["appAExpFWPresent"]
      );
    }

    convert_state_abbr_9089.forEach((field) => {
      if (initialValues[field]) {
        initialValues[field] = stateAbbreviationResolver(initialValues[field]);
      }
    });

    if (initialValues?.fwSkillsAppD?.[0]?.appASkillsStateId) {
      initialValues["fwSkillsAppD"][0]["appASkillsStateId"] =
        stateAbbreviationResolver(
          initialValues["fwSkillsAppD"][0]["appASkillsStateId"]
        );
    }
    if (initialValues?.fwExpAppE?.[0]?.appAExpStateTerritory) {
      initialValues["fwExpAppE"][0]["appAExpStateTerritory"] =
        stateAbbreviationResolver(
          initialValues["fwExpAppE"][0]["appAExpStateTerritory"]
        );
    }
    if (initialValues?.appAContStateId) {
      initialValues["appAContStateId"] = stateResolver(
        initialValues["appAContStateId"]
      );
    }

    if (initialValues["primaryWorksiteType"]) {
      let choices = {
        "Business Premises": "1",
        "Employer's private household (includes live-in and domestic household worker)":
          "2",
        "Employee's private residence (when work is performed directly out of the residence)":
          "3",
        "No one specific worksite address or physical location": "4",
      };
      initialValues["primaryWorksiteType"] =
        choices[initialValues["primaryWorksiteType"]];
    }
    initialValues["appx_b"] = [];
  }

  if (formType === "790A") {
    let addmHousing = formValues?.eta_790a_addendum_b_housing;
    if (
      formValues.form_version_id === 2 &&
      formValues?.eta_790a_d9_housing_standards_state === "1"
    ) {
      //formValues does not work as intended; has to be initialValues
      initialValues.eta_790a_d9_housing_standards_other_state = "1";
      initialValues.eta_790a_d9_housing_standards_state = "0";
    }
    for (let i = 0; i < addmHousing?.length; i++) {
      for (let item in addmHousing[i]) {
        if (
          formValues.form_version_id === 2 &&
          item === "applicable_housing_standards_state" &&
          addmHousing[i][item] === "true"
        ) {
          //initialValues does not work as intended; has to be formValues
          addmHousing[i].applicable_housing_standards_other_state = "true";
          addmHousing[i].applicable_housing_standards_state = "";
        }
      }
    }

    const convert_to_check_790A = [
      "eta_790a_b4a_certification_req",
      "eta_790a_b4b_driver_req",
      "eta_790a_b4c_background_req",
      "eta_790a_b4d_drug_screen_req",
      "eta_790a_b4e_lifting_req",
      "eta_790a_b4g_temperature_req",
      "eta_790a_b4h_pushing_req",
      "eta_790a_b4i_walking_req",
      "eta_790a_b4j_bending_req",
      "eta_790a_b4k_rep_motion_req",
      "eta_790a_d9_housing_standards_federal",
      "eta_790a_d9_housing_standards_local",
      "eta_790a_d9_housing_standards_state",
      "eta_790a_d9_housing_standards_other",
      "eta_790a_d9_housing_standards_swa",
      "eta_790a_d9_housing_standards_other_state",
    ];
    const convert_to_yes_no_790A = [
      "eta_790a_a5_is_247",
      "eta_790a_a9_is_addendum_a_completed",
      "eta_790a_b5a_is_supervising",
      "eta_790a_e2a_will_not_charge",
      "eta_790a_e2b_will_charge",
      "isOvertimeAvailable",
      "isPayDeductions",
      "minProductivity",
      "isMealProvision",
      "isDailyTransport",
      "isEmploymentTransport",
    ];

    const convert_to_yes_no_790AV2 = [
      "eta_790a_a5_is_247",
      "eta_790a_a9_is_addendum_a_completed",
      // V2 790A
      "eta_790a_h1_is_addendum_c_completed",
      "eta_790a_b5a_is_supervising",
      "eta_790a_e2a_will_not_charge",
      "eta_790a_e2b_will_charge",
    ];

    const convert_to_yes_not_applicable_790A = [
      "eta_790a_d11_is_housing_addendum_b_completed",
      "eta_790a_c7_is_work_addendum_b_completed",
    ];

    const convert_to_date_790A = [
      "eta_790a_a3_begin_date",
      "eta_790a_a4_end_date",
    ];

    const convert_to_number_790A = ["eta_790a_a6a_hours_total"];

    const convert_to_lowercase_790A = ["eta_790a_a8c_wage_offer_per"];
    const delete_values = ["eta_790a_a3_begin_date", "eta_790a_a4_end_date"];
    delete_values.forEach((val) => delete initialValues[val]);
    if (initialValues["eta_790a_a10_frequency_of_pay"]) {
      initialValues["eta_790a_a10_frequency_of_pay"] = convertPer(
        initialValues["eta_790a_a10_frequency_of_pay"]
      );
    }

    convert_to_date_790A.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertUnixDate(initialValues[string]);
      }
    });

    convert_to_check_790A.forEach((string) => {
      if (initialValues[string]) {
        if (initialValues[string] === "1") {
          initialValues[string] = convertToYesNo(initialValues[string]);
        } else if (initialValues[string] === "0") {
          delete initialValues[string];
        }
      }
    });

    if (formVersionId <= 2) {
      convert_to_yes_no_790AV2.forEach((string) => {
        if (initialValues[string]) {
          initialValues[string] = convertToYesNo(initialValues[string]);
        }
      });
    } else {
      convert_to_yes_no_790A.forEach((string) => {
        if (initialValues[string]) {
          initialValues[string] = convertToYesNo(initialValues[string]);
        }
      });
    }

    convert_to_yes_not_applicable_790A.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertToYesNA(initialValues[string]);
      }
    });

    convert_to_number_790A.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertToNumber(initialValues[string]);
      }
    });

    convert_to_lowercase_790A.forEach((string) => {
      if (initialValues[string]) {
        initialValues[string] = convertToLowerCase(initialValues[string]);
      }
    });

    if (initialValues["eta_790a_b1_education_level"]) {
      initialValues["eta_790a_b1_education_level"] = convertEducation(
        initialValues["eta_790a_b1_education_level"]
      );
    }

    // OFLCW-3771
    if (
      initialValues["prelim_2_employer_type"] === "joint" ||
      initialValues["prelim_2_employer_type"] === "association-joint" ||
      initialValues["prelim_3_is_contractor"] === "YES"
    ) {
      initialValues["eta_790a_c7_is_work_addendum_b_completed"] = "YES";
    }

    if (formVersionId <= 2) {
      // V2
      if (initialValues["eta_790a_d6_housing_type_employer"]) {
        initialValues["eta_790a_d6_housing_type"] = "Employer";
      }
      if (initialValues["eta_790a_d6_housing_type_rental"]) {
        initialValues["eta_790a_d6_housing_type"] = "Rental";
      }

      if (initialValues["eta_790a_addendum_b_employment"]) {
        // set c.7 needed to visually show addendum b
        if (formValues["eta_790a_c7_is_work_addendum_b_completed"] === "1") {
          initialValues["eta_790a_c7_is_work_addendum_b_completed"] = "YES";
        }
        if (formValues["eta_790a_a2a_workers_needed_total"]) {
          initialValues["eta_790a_a2a_workers_needed_total"] =
            formValues["eta_790a_a2a_workers_needed_total"];
        }
        if (formValues["eta_790a_a2b_workers_needed_h2a"]) {
          initialValues["eta_790a_a2b_workers_needed_h2a"] =
            formValues["eta_790a_a2b_workers_needed_h2a"];
        }

        initialValues["eta_790a_addendum_b_employment"].forEach(
          (field, index) => {
            if (
              initialValues["eta_790a_addendum_b_employment"][index][
                "employment_additional_info"
              ]
            ) {
              initialValues["eta_790a_addendum_b_employment"][index][
                "additional_info"
              ] =
                initialValues["eta_790a_addendum_b_employment"][index][
                  "employment_additional_info"
                ];
            }

            initialValues["eta_790a_addendum_b_employment"][index]["end_date"] =
              null;

            initialValues["eta_790a_addendum_b_employment"][index][
              "begin_date"
            ] = null;

            initialValues["eta_790a_addendum_b_employment"][index][
              "error"
            ] = true;

            const delete_values = [
              "addendum_type",
              "employment_additional_info",
              "applicable_housing_standards_local",
              "applicable_housing_standards_state",
              "applicable_housing_standards_federal",
              "applicable_housing_standards_other",
              "applicable_housing_standards_other_text",
              "applicable_housing_standards_swa",
              "housing_additional_info",
              "housing_address_1",
              "housing_address_2",
              "housing_city",
              "housing_standards",
              "housing_type",
              "housing_zip",
              "physical_location",
              "place_of_employment",
              "total_occ",
              "total_units",
              "county_name",
            ];

            delete_values.forEach(
              (val) =>
                delete initialValues["eta_790a_addendum_b_employment"][index][
                  val
                ]
            );
          }
        );
      }

      // addendum B housing
      if (initialValues["eta_790a_addendum_b_housing"]) {
        initialValues["eta_790a_addendum_b_housing"].map((field, index) => {
          // loop through housing identities convert to checkbox array
          [
            "applicable_housing_standards_federal",
            "applicable_housing_standards_local",
            "applicable_housing_standards_other",
            "applicable_housing_standards_state",
            "applicable_housing_standards_swa",
            "applicable_housing_standards_other_state",
          ].forEach((field) => {
            if (
              initialValues["eta_790a_addendum_b_housing"][
                index
              ].hasOwnProperty(field)
            ) {
              const value =
                initialValues["eta_790a_addendum_b_housing"][index][field];
              if (value === "") {
                initialValues["eta_790a_addendum_b_housing"][index][field] = [];
              }
              if (value == "true") {
                initialValues["eta_790a_addendum_b_housing"][index][field] = [
                  "YES",
                ];
              }
            }
          });

          const delete_values = [
            "addendum_type",
            "housing_additional_info",
            "employment_additional_info",
            "employment_address_1",
            "employment_address_2",
            "employment_city",
            "employment_zip",
            "physical_location",
            "place_of_employment",
            "total_workers",
            "business_name",
            "begin_date",
            "end_date",
            "housing_standards",
            // "applicable_housing_standards_local",
            // "applicable_housing_standards_state",
            // "applicable_housing_standards_federal",
            "county_name",
          ];

          delete_values.forEach(
            (val) =>
              delete initialValues["eta_790a_addendum_b_housing"][index][val]
          );
        });
      }
    } else {
      // V3
      // addendum B additional POC
      if (initialValues["eta_790a_addendum_b_employment"]) {
        initialValues["eta_790a_addendum_b_employment"].forEach(
          (field, index) => {
            if (
              initialValues["eta_790a_addendum_b_employment"][index]["end_date"]
            ) {
              initialValues["eta_790a_addendum_b_employment"][index][
                "end_date"
              ] = convertUnixDate(
                parseInt(
                  initialValues["eta_790a_addendum_b_employment"][index][
                    "end_date"
                  ]
                )
              );
            }

            if (
              initialValues["eta_790a_addendum_b_employment"][index][
                "begin_date"
              ]
            ) {
              initialValues["eta_790a_addendum_b_employment"][index][
                "begin_date"
              ] = convertUnixDate(
                parseInt(
                  initialValues["eta_790a_addendum_b_employment"][index][
                    "begin_date"
                  ]
                )
              );
            }

            const delete_values = [
              "addendum_type",
              "employment_additional_info",
              "applicable_housing_standards_local",
              "applicable_housing_standards_state",
              "applicable_housing_standards_federal",
              "applicable_housing_standards_other",
              "applicable_housing_standards_other_text",
              "applicable_housing_standards_swa",
              "housing_additional_info",
              "housing_address_1",
              "housing_address_2",
              "housing_city",
              "housing_standards",
              "housing_type",
              "housing_zip",
              "physical_location",
              "place_of_employment",
              "total_occ",
              "total_units",
              "county_name",
            ];

            if (!initialValues["eta_790a_addendum_a"]) {
              delete_values.push("crop_ids");
            }

            delete_values.forEach(
              (val) =>
                delete initialValues["eta_790a_addendum_b_employment"][index][
                  val
                ]
            );
          }
        );
      }

      // addendum B housing
      if (initialValues["eta_790a_addendum_b_housing"]) {
        initialValues["eta_790a_addendum_b_housing"].map((field, index) => {
          const delete_values = [
            "addendum_type",
            "housing_additional_info",
            "employment_additional_info",
            "employment_address_1",
            "employment_address_2",
            "employment_city",
            "employment_zip",
            "physical_location",
            "place_of_employment",
            "total_workers",
            "legalName",
            "agricFeinId",
            "begin_date",
            "end_date",
            "housing_standards",
            // "applicable_housing_standards_local",
            // "applicable_housing_standards_state",
            // "applicable_housing_standards_federal",
            "county_name",
          ];

          delete_values.forEach(
            (val) =>
              delete initialValues["eta_790a_addendum_b_housing"][index][val]
          );
        });
      }
    }

    if (initialValues["eta_790a_addendum_c"]) {
      initialValues["eta_790a_addendum_c"].forEach((record, index) => {
        let section_title;
        if (formVersionId <= 2) {
          section_title = convertSummaryPrefixToTitleV2(
            initialValues["eta_790a_addendum_c"][index]["section_number"]
          );
        } else {
          section_title = convertSummaryPrefixToTitle(
            initialValues["eta_790a_addendum_c"][index]["section_number"]
          );
        }
        initialValues["eta_790a_addendum_c"][index]["section_number"] =
          section_title;

        // find the section title inside the title? remove to only show the summary
        if (
          initialValues["eta_790a_addendum_c"][index]["section_name"] &&
          initialValues["eta_790a_addendum_c"][index]["section_name"].indexOf(
            `${section_title} - `
          ) > -1
        ) {
          initialValues["eta_790a_addendum_c"][index]["section_name"] =
            initialValues["eta_790a_addendum_c"][index]["section_name"].replace(
              `${section_title} - `,
              ""
            );
        } else if (
          initialValues["eta_790a_addendum_c"][index]["section_name"] ===
          section_title
        ) {
          initialValues["eta_790a_addendum_c"][index]["section_name"] = "";
        }
      });
    }
  }

  const naicsFieldMapping = {
    9035: { code: "c13_emp_naics", desc: "c13_emp_naics_description" },
    "790A": {
      code: "eta_790_b16_poc_naics",
      desc: "eta_790_b16_poc_naics_description",
    },
  };
  // Use 9141 and 9089 fields by default
  const naicsCodeField = naicsFieldMapping[formType]?.code ?? "empNaics";
  const naicsDescField = naicsFieldMapping[formType]?.desc ?? "empNaicsDesc";

  const naicsCode = initialValues[naicsCodeField];
  const naicsDesc = initialValues[naicsDescField];
  if (util.isBadNaics(naicsCode, naicsDesc)) {
    initialValues[naicsCodeField] = null;
    initialValues[naicsDescField] = null;
  }
  return initialValues;
};

//set valid reuse sections for form version 1 for 790A
export const updateValidSections = () => {
  return ["ADD B Place"];
};

export const getReUseTable = (
  validSections = undefined,
  formType,
  formVersionId
) => {
  return (
    UISchemaResolver(
      `${formType}${formVersionId ? "V" + formVersionId : ""}-reuse-sections`
    ) || []
  );
};
